import React from 'react'
import InitiativeLogCard from './InitiativeLogs/InitiativeLogCard';

class InitiativeLogs extends React.Component {

    render() {
        let initiativeLogs = [];
        if (this.props.selectedDataById.initativeLogs && this.props.selectedDataById.initativeLogs.length > 0) {
            initiativeLogs = this.props.selectedDataById.initativeLogs && this.props.selectedDataById.initativeLogs.map((item, i) => {
                return <InitiativeLogCard
                    item={item}
                    index={i}
                    key={i}
                    selectedDataById={this.props.selectedDataById} />
            })
        } else {
            initiativeLogs = "No Logs Found"
        }

        return (
            <div>
                {initiativeLogs}
            </div>
        )
    }
}

export default InitiativeLogs